module.exports = __webpack_public_path__ + "img/cate-1-a6ec90.png";